export enum ApplicationMenuSections {
    Dashboard = 1,
    Resource = 2,
    Services = 3,
    Reports = 4,
    Administrations = 5,
    Billing = 6,
    PatientCases = 7,
    DocumentVault = 8,
    FacilityMaster = 9,
    VobModule = 10,
}